import {parseHtml, labels} from "./commons";
import {JLocInfos} from "./api";

import {lang} from "./language-selector";
import {JSX} from "wfr/commons/jsx"

export {alertFromLocInfos, alert}



function s(key:string) {
	return labels[lang][key] as string
}

function close(){
	dialog()?.remove()
}

function dialog(){
	const dialog = document.body.children[document.body.children.length-1];
	if(dialog instanceof HTMLDialogElement) return dialog;
	else return null;
}

function alertFromLocInfos(infos:JLocInfos){
	alert(infos[lang].title, parseHtml(infos[lang].body))
}
function alert(title:string, body:Element){
	close()
	document.body.append(<dialog class="alert">
		<div class="head">
			{title? <div class="title"><span>{title}</span></div>:null}
			<div class="controls">
				<button class="remove" title={s("close")} onclick={close}><span>{s("close")}</span></button>
			</div>
		</div>
		<div class="content">{body}</div>
		<div class="footer">
			<div class="controls">
				<button class="remove" title={s("close")} onclick={close}><span>{s("close")}</span></button>
			</div>
		</div>
	</dialog>)
	dialog().showModal()
}
